import React from "react";

import Portal from "../../../platform/pages/business/portal";
import CareSchedulePage from "./CareSchedulePage";

/**
 * Keep Care's booking-provider settings inside the normal Care business shell.
 * Timely365 remains an external booking service; this wrapper only supplies the
 * Plany365 Care navigation around the integration settings page.
 */
export default function CareSchedulePortal(): JSX.Element {
  return <Portal title="Schedule" TabComponent={CareSchedulePage} props={{}} />;
}
